require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/resource/js/canvasRender.debug.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./resource/js/canvasRender.debug.js
// module id = gr98
// module chunks = 1